var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIosInActiveIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 36,
    viewBox: "0 0 30 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.4855 19.1263C24.4403 14.5689 28.2025 12.3819 28.3706 12.2736C26.256 9.18049 22.9615 8.75532 21.7876 8.70751C18.9841 8.42448 16.3181 10.359 14.8938 10.359C13.4734 10.359 11.2784 8.74998 8.95395 8.79255C5.89864 8.83772 3.08182 10.5696 1.50675 13.306C-1.66752 18.8134 0.694832 26.976 3.78872 31.4418C5.30006 33.6287 7.10243 36.0855 9.46944 35.9977C11.7481 35.9081 12.6104 34.5216 15.3668 34.5216C18.1225 34.5216 18.8964 35.9978 21.3086 35.9506C23.7613 35.9054 25.3152 33.7211 26.8166 31.5268C28.5539 28.989 29.266 26.5349 29.3092 26.4087C29.2547 26.3841 24.5266 24.5732 24.4788 19.1282L24.4854 19.1263H24.4855ZM19.9547 5.7485C21.2103 4.22518 22.0587 2.11059 21.8268 0C20.0178 0.0737391 17.8242 1.20575 16.5254 2.72711C15.3595 4.0777 14.3411 6.23013 14.6135 8.29753C16.6337 8.45502 18.6964 7.27114 19.9527 5.75114L19.9547 5.7485Z",
    fill: "#8D9091"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIosInActiveIcon);
export default __webpack_public_path__ + "static/media/iosInActiveIcon.6c1a07346e3d331e5a47b8321221e9c0.svg";
export { ForwardRef as ReactComponent };